import { render, staticRenderFns } from "./CheckboxCell.vue?vue&type=template&id=2c72bdfe&scoped=true&"
import script from "./CheckboxCell.vue?vue&type=script&lang=js&"
export * from "./CheckboxCell.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxCell.vue?vue&type=style&index=0&id=2c72bdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72bdfe",
  null
  
)

component.options.__file = "CheckboxCell.vue"
export default component.exports